import React, { ReactElement } from 'react'
import ErrorPage from 'ui/atoms/ErrorPage'
import GoToSignInButton from 'ui/atoms/GoToSignInButton'
import { translate } from 'helpers'
import { clientInfo } from 'configureBrand'
import { FA_LOCK } from 'const/iconProp'

const SoftenerError = (): ReactElement => (
  <ErrorPage
    title={translate({ string: 'softenerValidationFailedTitle' })}
    description={translate({
      string: 'softenerValidationFailedBody',
      argument: clientInfo.phoneNumbers.customerService
    })}
    errorIcon={FA_LOCK}
    data-testid="softener-error"
  >
    <GoToSignInButton />
  </ErrorPage>
)

export default SoftenerError
